import { NgModule, ErrorHandler } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { GlobalErrorHandler } from './services/global-error-handler.service';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { AuthorizationInterceptor } from './appAuth/AuthorizationInterceptor';
import { NgxPaginationModule } from 'ngx-pagination';
import { FormsModule , ReactiveFormsModule} from '@angular/forms';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MessageService, ConfirmationService } from 'primeng/api';
import { SharedComponentsModule } from './shared/components/shared-components.module';

@NgModule({
  declarations: [AppComponent  ],
  imports: [
              CommonModule,
              BrowserModule, 
              IonicModule.forRoot(), 
              AppRoutingModule, 
              NgxDatatableModule, 
              HttpClientModule, 
              NgxPaginationModule, 
              FormsModule, 
              ReactiveFormsModule,
              BrowserAnimationsModule,
              SharedComponentsModule
            ],
  

  providers: 
  [
      { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
      { provide: HTTP_INTERCEPTORS, useClass: AuthorizationInterceptor, multi: true },
      { provide: ErrorHandler, useClass: GlobalErrorHandler },
      MessageService,
      ConfirmationService
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }
